import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	isVisible: boolean
	hasError: boolean
}

export const Placeholder = styled.label<Props>`
	display: block;
	position: absolute;
	pointer-events: none;
	font: ${helpers.fonts.input.content};
	margin-top: 2px;
	opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
	transition: color 0.2s, opacity 0.2s;
	color: ${({ hasError, theme }) => {
		if (hasError) {
			return theme.color.input.placeholderError
		}
		return theme.color.input.placeholder
	}};
`
